import './assets/index-DuYzGG0a.css';
import { openBlock, createElementBlock, createElementVNode, resolveDirective, normalizeClass, renderSlot, normalizeProps, guardReactiveProps, Fragment, renderList, mergeProps, createTextVNode, toDisplayString, withKeys, withModifiers, createBlock, resolveDynamicComponent, createCommentVNode, toHandlers, withDirectives, vShow, createVNode, Transition, withCtx, warn } from "vue";
const appendToBody = {
  mounted(el, { instance }) {
    if (instance.appendToBody) {
      document.body.appendChild(el);
      const { height, top, left, width } = instance.$refs.toggle.getBoundingClientRect();
      const scrollX = window.scrollX || window.pageXOffset;
      const scrollY = window.scrollY || window.pageYOffset;
      el.unbindPosition = instance.calculatePosition(el, instance, {
        width: width + "px",
        left: scrollX + left + "px",
        top: scrollY + top + height + "px"
      });
    }
  },
  unmounted(el, { instance }) {
    if (instance.appendToBody) {
      if (el.unbindPosition && typeof el.unbindPosition === "function") {
        el.unbindPosition();
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
};
const ajax = {
  props: {
    /**
     * Toggles the adding of a 'loading' class to the main
     * .v-select wrapper. Useful to control UI state when
     * results are being processed through AJAX.
     */
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mutableLoading: false
    };
  },
  watch: {
    /**
     * Anytime the search string changes, emit the
     * 'search' event. The event is passed with two
     * parameters: the search string, and a function
     * that accepts a boolean parameter to toggle the
     * loading state.
     *
     * @fires 'search'
     */
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    /**
     * Sync the loading prop with the internal
     * mutable loading value.
     *
     * @param val Incoming loading state.
     */
    loading(val) {
      this.mutableLoading = val;
    }
  },
  methods: {
    /**
     * Toggle this.loading. Optionally pass a boolean
     * value. If no value is provided, this.loading
     * will be set to the opposite of it's current value.
     *
     * @param toggle Boolean
     * @return {*}
     */
    toggleLoading(toggle = null) {
      if (toggle === null || toggle === void 0) {
        return this.mutableLoading = !this.mutableLoading;
      }
      return this.mutableLoading = toggle;
    }
  }
};
const pointerScroll = {
  props: {
    autoscroll: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    typeAheadPointer() {
      if (this.autoscroll) {
        this.maybeAdjustScroll();
      }
    },
    open(open) {
      if (this.autoscroll && open) {
        this.$nextTick(() => this.maybeAdjustScroll());
      }
    }
  },
  methods: {
    /**
     * Adjust the scroll position of the dropdown list
     * if the current pointer is outside of the
     * overflow bounds.
     *
     * @return {*}
     */
    maybeAdjustScroll() {
      const optionEl = this.$refs.dropdownMenu?.children[this.typeAheadPointer] || false;
      if (optionEl) {
        const bounds = this.getDropdownViewport();
        const { top, bottom, height } = optionEl.getBoundingClientRect();
        if (top < bounds.top) {
          return this.$refs.dropdownMenu.scrollTop = optionEl.offsetTop;
        } else if (bottom > bounds.bottom) {
          return this.$refs.dropdownMenu.scrollTop = optionEl.offsetTop - (bounds.height - height);
        }
      }
    },
    /**
     * The currently viewable portion of the dropdownMenu.
     *
     * @return {{top: (string|*|number), bottom: *}}
     */
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
};
const pointer = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      if (!this.resetFocusOnOptionsChange) {
        return;
      }
      for (let i = 0; i < this.filteredOptions.length; i++) {
        if (this.selectable(this.filteredOptions[i])) {
          this.typeAheadPointer = i;
          break;
        }
      }
    },
    open(open) {
      if (open) {
        this.typeAheadToLastSelected();
      }
    },
    selectedValue() {
      if (this.open) {
        this.typeAheadToLastSelected();
      }
    }
  },
  methods: {
    /**
     * Move the typeAheadPointer visually up the list by
     * setting it to the previous selectable option.
     *
     * @return {void}
     */
    typeAheadUp() {
      for (let i = this.typeAheadPointer - 1; i >= 0; i--) {
        if (this.selectable(this.filteredOptions[i])) {
          this.typeAheadPointer = i;
          break;
        }
      }
    },
    /**
     * Move the typeAheadPointer visually down the list by
     * setting it to the next selectable option.
     *
     * @return {void}
     */
    typeAheadDown() {
      for (let i = this.typeAheadPointer + 1; i < this.filteredOptions.length; i++) {
        if (this.selectable(this.filteredOptions[i])) {
          this.typeAheadPointer = i;
          break;
        }
      }
    },
    /**
     * Select the option at the current typeAheadPointer position.
     * Optionally clear the search input on selection.
     *
     * @return {void}
     */
    typeAheadSelect() {
      const typeAheadOption = this.filteredOptions[this.typeAheadPointer];
      if (typeAheadOption && this.selectable(typeAheadOption)) {
        this.select(typeAheadOption);
      }
    },
    /**
     * Moves the pointer to the last selected option.
     */
    typeAheadToLastSelected() {
      const indexOfLastSelected = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
      if (indexOfLastSelected !== -1) {
        this.typeAheadPointer = indexOfLastSelected;
      }
    }
  }
};
function sortAndStringify(sortable) {
  const ordered = {};
  Object.keys(sortable).sort().forEach((key) => {
    ordered[key] = sortable[key];
  });
  return JSON.stringify(ordered);
}
let idCount = 0;
function uniqueId() {
  return ++idCount;
}
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$2 = {};
const _hoisted_1$2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
};
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$2, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1)
  ])]);
}
const Deselect = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = {};
const _hoisted_1$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
};
function _sfc_render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1)
  ])]);
}
const OpenIndicator = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const childComponents = {
  Deselect,
  OpenIndicator
};
const _sfc_main = {
  components: { ...childComponents },
  directives: { appendToBody },
  mixins: [pointerScroll, pointer, ajax],
  props: {
    /**
     * Contains the currently selected value. Very similar to a
     * `value` attribute on an <input>. You can listen for changes
     * with the 'input' event.
     *
     * @type {object | string | Array | null}
     */
    modelValue: {},
    /**
     * An object with any custom components that you'd like to overwrite
     * the default implementation of in your app. The keys in this object
     * will be merged with the defaults.
     *
     * @see https://vue-select.org/guide/components.html
     * @type {Function}
     */
    components: {
      type: Object,
      default: () => ({})
    },
    /**
     * An array of strings or objects to be used as dropdown choices.
     * If you are using an array of objects, vue-select will look for
     * a `label` key (ex. [{label: 'This is Foo', value: 'foo'}]). A
     * custom label key can be set with the `label` prop.
     *
     * @type {Array}
     */
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Sets the maximum number of options to display in the dropdown list
     *
     * @type {number}
     */
    limit: {
      type: Number,
      default: null
    },
    /**
     * Disable the entire component.
     *
     * @type {boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Can the user clear the selected property.
     *
     * @type {boolean}
     */
    clearable: {
      type: Boolean,
      default: true
    },
    /**
     * Can the user deselect an option by clicking it from
     * within the dropdown.
     *
     * @type {boolean}
     */
    deselectFromDropdown: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/disable filtering the options.
     *
     * @type {boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     *
     * @type {boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to the `placeholder` attribute on an `<input>`.
     *
     * @type {string}
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Sets a Vue transition property on the `.vs__dropdown-menu`.
     *
     * @type {string}
     */
    transition: {
      type: String,
      default: "vs__fade"
    },
    /**
     * Enables/disables clearing the search text when an option is selected.
     *
     * @type {boolean}
     */
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Close a dropdown when an option is chosen. Set to false to keep the dropdown
     * open (useful when combined with multi-select, for example)
     *
     * @type {boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Tells vue-select what key to use when generating option
     * labels when each `option` is an object.
     *
     * @type {string}
     */
    label: {
      type: String,
      default: "label"
    },
    /**
     * Allows to customize the `aria-label` set on the comobobox for searching options.
     *
     * @type {string}
     * @default 'Search for options'
     */
    ariaLabelCombobox: {
      type: String,
      default: "Search for options"
    },
    /**
     * Allows to customize the `aria-label` set on the listbox element.
     *
     * @type {string}
     * @default 'Options'
     */
    ariaLabelListbox: {
      type: String,
      default: "Options"
    },
    /**
     * Allows to customize the `aria-label` set on the clear-selected button
     *
     * @type {string}
     * @default 'Clear selected'
     */
    ariaLabelClearSelected: {
      type: String,
      default: "Clear selected"
    },
    /**
     * Allows to customize the `aria-label` for the deselect-option button
     * The default is "Deselect " + optionLabel
     *
     * @type {(optionLabel: string) => string}
     */
    ariaLabelDeselectOption: {
      type: Function,
      default: (optionLabel) => `Deselect ${optionLabel}`
    },
    /**
     * Value of the 'autocomplete' field of the input
     * element.
     *
     * @type {string}
     */
    autocomplete: {
      type: String,
      default: "off"
    },
    /**
     * When working with objects, the reduce
     * prop allows you to transform a given
     * object to only the information you
     * want passed to a v-model binding
     * or \@input event.
     */
    reduce: {
      type: Function,
      default: (option) => option
    },
    /**
     * Decides whether an option is selectable or not. Not selectable options
     * are displayed but disabled and cannot be selected.
     *
     * @type {Function}
     * @since 3.3.0
     * @param {object | string} option
     * @return {boolean}
     */
    selectable: {
      type: Function,
      default: () => true
    },
    /**
     * Callback to generate the label text. If {option}
     * is an object, returns option[this.label] by default.
     *
     * Label text is used for filtering comparison and
     * displaying. If you only need to adjust the
     * display, you should use the `option` and
     * `selected-option` slots.
     *
     * @type {Function}
     * @param  {object | string} option
     * @return {string}
     */
    getOptionLabel: {
      type: Function,
      default(option) {
        if (typeof option === "object") {
          if (!Object.hasOwn(option, this.label)) {
            return warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(option)}.
https://vue-select.org/api/props.html#getoptionlabel`);
          }
          return option[this.label];
        }
        return option;
      }
    },
    /**
     * Generate a unique identifier for each option. If `option`
     * is an object and `option.hasOwnProperty('id')` exists,
     * `option.id` is used by default, otherwise the option
     * will be serialized to JSON.
     *
     * If you are supplying a lot of options, you should
     * provide your own keys, as JSON.stringify can be
     * slow with lots of objects.
     *
     * The result of this function *must* be unique.
     *
     * @type {Function}
     * @param  {object | string} option
     * @return {string}
     */
    getOptionKey: {
      type: Function,
      default(option) {
        if (typeof option !== "object") {
          return option;
        }
        try {
          return Object.hasOwn(option, "id") ? option.id : sortAndStringify(option);
        } catch (e) {
          const warning = "[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey";
          return warn(warning, option, e);
        }
      }
    },
    /**
     * Select the current value if selectOnTab is enabled
     *
     * @deprecated since 3.3
     */
    onTab: {
      type: Function,
      default() {
        if (this.selectOnTab && !this.isComposing) {
          this.typeAheadSelect();
        }
      }
    },
    /**
     * Enable/disable creating options from searchEl.
     *
     * @type {boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },
    /**
     * Set the tabindex for the input field.
     *
     * @type {number}
     */
    tabindex: {
      type: Number,
      default: null
    },
    /**
     * When true, newly created tags will be added to
     * the options list.
     *
     * @type {boolean}
     */
    pushTags: {
      type: Boolean,
      default: false
    },
    /**
     * When true, existing options will be filtered
     * by the search text. Should not be used in conjunction
     * with taggable.
     *
     * @type {boolean}
     */
    filterable: {
      type: Boolean,
      default: true
    },
    /**
     * Callback to determine if the provided option should
     * match the current search text. Used to determine
     * if the option should be displayed.
     *
     * @type {Function}
     * @param  {object | string} option
     * @param  {string} label
     * @param  {string} search
     * @return {boolean}
     */
    filterBy: {
      type: Function,
      default(option, label, search) {
        return (label || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
      }
    },
    /**
     * Callback to filter results when search text
     * is provided. Default implementation loops
     * each option, and returns the result of
     * this.filterBy.
     *
     * @type {Function}
     * @param  {Array} list of options
     * @param  {string} search text
     * @param  {object} vSelect instance
     * @return {boolean}
     */
    filter: {
      type: Function,
      default(options, search) {
        return options.filter((option) => {
          let label = this.getOptionLabel(option);
          if (typeof label === "number") {
            label = label.toString();
          }
          return this.filterBy(option, label, search);
        });
      }
    },
    /**
     * User defined function for adding Options
     *
     * @type {Function}
     */
    createOption: {
      type: Function,
      default(option) {
        return typeof this.optionList[0] === "object" ? { [this.label]: option } : option;
      }
    },
    /**
     * If false, the focused dropdown option will not be reset when filtered
     * options change.
     *
     * @type {boolean}
     */
    resetFocusOnOptionsChange: {
      type: Boolean,
      default: true
    },
    /**
     * When false, updating the options will not reset the selected value. Accepts
     * a `boolean` or `function` that returns a `boolean`. If defined as a function,
     * it will receive the params listed below.
     *
     * @since 3.4 - Type changed to {boolean | Function}
     *
     * @type {boolean | Function}
     * @param {Array} newOptions
     * @param {Array} oldOptions
     * @param {Array} selectedValue
     */
    resetOnOptionsChange: {
      default: false,
      validator: (value) => ["function", "boolean"].includes(typeof value)
    },
    /**
     * If search text should clear on blur
     *
     * @return {boolean} True when single and clearSearchOnSelect
     */
    clearSearchOnBlur: {
      type: Function,
      default({ clearSearchOnSelect, multiple }) {
        return clearSearchOnSelect && !multiple;
      }
    },
    /**
     * Disable the dropdown entirely.
     *
     * @type {boolean}
     */
    noDrop: {
      type: Boolean,
      default: false
    },
    /**
     * Sets the id of the input element.
     *
     * @type {string}
     * @default {null}
     */
    inputId: {
      type: String
    },
    /**
     * Sets RTL support. Accepts 'ltr', 'rtl', 'auto'.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir
     * @type {string}
     * @default 'auto'
     */
    dir: {
      type: String,
      default: "auto"
    },
    /**
     * When true, hitting the 'tab' key will select the current select value
     *
     * @type {boolean}
     * @deprecated since 3.3 - use selectOnKeyCodes instead
     */
    selectOnTab: {
      type: Boolean,
      default: false
    },
    /**
     * Keycodes that will select the current option.
     *
     * @type Array
     */
    selectOnKeyCodes: {
      type: Array,
      default: () => [
        // enter
        13
      ]
    },
    /**
     * Query Selector used to find the search input
     * when the 'search' scoped slot is used.
     *
     * Must be a valid CSS selector string.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
     * @type {string}
     */
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    /**
     * Used to modify the default keydown events map
     * for the search input. Can be used to implement
     * custom behaviour for key presses.
     */
    mapKeydown: {
      type: Function,
      /**
       * @param {object} map Existing keydown handlers map.
       * @param {VueSelect} vm Component instance.
       * @return {object}
       */
      default: (map) => map
    },
    /**
     * Append the dropdown element to the end of the body
     * and size/position it dynamically. Use it if you have
     * overflow or z-index issues.
     *
     * @type {boolean}
     */
    appendToBody: {
      type: Boolean,
      default: false
    },
    /**
     * When `appendToBody` is true, this function is responsible for
     * positioning the drop down list.
     *
     * If a function is returned from `calculatePosition`, it will
     * be called when the drop down list is removed from the DOM.
     * This allows for any garbage collection you may need to do.
     *
     * @since v3.7.0
     * @see http://vue-select.org/guide/positioning.html
     */
    calculatePosition: {
      type: Function,
      /**
       * @param {HTMLUListElement} dropdownList Dropdown list element.
       * @param {Vue} component Component instance.
       * @param {object} width Computed dropdown coordinates.
       * @param {string} width.width Computed width value.
       * @param {string} width.top Computed top position.
       * @param {string} width.left Computed left position.
       * @return {Function | void}
       */
      default(dropdownList, component, { width, top, left }) {
        dropdownList.style.top = top;
        dropdownList.style.left = left;
        dropdownList.style.width = width;
      }
    },
    /**
     * Determines whether the dropdown should be open.
     * Receives the component instance as the only argument.
     *
     * @since v3.12.0
     * @return {boolean}
     */
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop, open, mutableLoading }) {
        return noDrop ? false : open && !mutableLoading;
      }
    },
    /**
     * Display a visible border around dropdown options
     * which have keyboard focus.
     */
    keyboardFocusBorder: {
      type: Boolean,
      default: false
    },
    /**
     * A unique identifier used to generate IDs in HTML.
     * Must be unique for every instance of the component.
     */
    uid: {
      type: [String, Number],
      default: () => uniqueId()
    }
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  data() {
    return {
      search: "",
      open: false,
      isComposing: false,
      isKeyboardNavigation: false,
      pushedTags: [],
      // eslint-disable-next-line vue/no-reserved-keys
      _value: [],
      // Internal value managed by Vue Select if no `modelValue` prop is passed
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    /**
     * Determine if the component needs to
     * track the state of values internally.
     *
     * @return {boolean}
     */
    isTrackingValues() {
      return typeof this.modelValue === "undefined" || this.isReducingValues;
    },
    /**
     * The options that are currently selected.
     *
     * @return {Array}
     */
    selectedValue() {
      let value = this.modelValue;
      if (this.isTrackingValues) {
        value = this.$data._value;
      }
      if (value !== void 0 && value !== null && value !== "") {
        return [].concat(value);
      }
      return [];
    },
    /**
     * The options available to be chosen
     * from the dropdown, including any
     * tags that have been pushed.
     *
     * @return {Array}
     */
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    /**
     * Find the search input DOM element.
     *
     * @return {HTMLInputElement}
     */
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    /**
     * The object to be bound to the $slots.search slot.
     *
     * @return {object}
     */
    scope() {
      const listSlot = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: {
            id: this.inputId,
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-label": this.ariaLabelCombobox,
            "aria-controls": `vs-${this.uid}__listbox`,
            "aria-owns": `vs-${this.uid}__listbox`,
            "aria-expanded": this.dropdownOpen.toString(),
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search,
            ...this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
              "aria-activedescendant": `vs-${this.uid}__option-${this.typeAheadPointer}`
            } : {}
          },
          events: {
            compositionstart: () => this.isComposing = true,
            compositionend: () => this.isComposing = false,
            keydown: this.onSearchKeyDown,
            keypress: this.onSearchKeyPress,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (e) => this.search = e.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: listSlot,
        listFooter: listSlot,
        header: { ...listSlot, deselect: this.deselect },
        footer: { ...listSlot, deselect: this.deselect }
      };
    },
    /**
     * Returns an object containing the child components
     * that will be used throughout the component. The
     * `component` prop can be used to overwrite the defaults.
     *
     * @return {object}
     */
    childComponents() {
      return {
        ...childComponents,
        ...this.components
      };
    },
    /**
     * Holds the current state of the component.
     *
     * @return {object}
     */
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    /**
     * Return the current state of the
     * search input
     *
     * @return {boolean} True if non empty value
     */
    searching() {
      return !!this.search;
    },
    /**
     * Return the current state of the
     * dropdown menu.
     *
     * @return {boolean} True if open
     */
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    /**
     * Return the placeholder string if it's set
     * & there is no value selected.
     *
     * @return {string} Placeholder text
     */
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    /**
     * The currently displayed options, filtered
     * by the search elements value. If tagging
     * true, the search text will be prepended
     * if it doesn't already exist.
     *
     * @return {Array}
     */
    filteredOptions() {
      const limitOptions = (options2) => {
        if (this.limit !== null) {
          return options2.slice(0, this.limit);
        }
        return options2;
      };
      const optionList = [].concat(this.optionList);
      if (!this.filterable && !this.taggable) {
        return limitOptions(optionList);
      }
      const options = this.search.length ? this.filter(optionList, this.search, this) : optionList;
      if (this.taggable && this.search.length) {
        try {
          const createdOption = this.createOption(this.search);
          if (!this.optionExists(createdOption)) {
            options.unshift(createdOption);
          }
        } catch {
        }
      }
      return limitOptions(options);
    },
    /**
     * Check if there aren't any options selected.
     *
     * @return {boolean}
     */
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    /**
     * Determines if the clear button should be displayed.
     *
     * @return {boolean}
     */
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    /**
     * Maybe reset the value
     * when options change.
     * Make sure selected option
     * is correct.
     *
     * @param {Array} newOptions Updated options list.
     * @param {Array} oldOptions Previous options list.
     * @return {boolean} [description]
     */
    options(newOptions, oldOptions) {
      const shouldReset = () => typeof this.resetOnOptionsChange === "function" ? this.resetOnOptionsChange(
        newOptions,
        oldOptions,
        this.selectedValue
      ) : this.resetOnOptionsChange;
      if (!this.taggable && shouldReset()) {
        this.clearSelection();
      }
      if (this.modelValue && this.isTrackingValues) {
        this.setInternalValueFromOptions(this.modelValue);
      }
    },
    /**
     * Make sure to update internal
     * value if prop changes outside
     */
    modelValue: {
      immediate: true,
      handler(val) {
        if (this.isTrackingValues) {
          this.setInternalValueFromOptions(val);
        }
      }
    },
    /**
     * Always reset the value when
     * the multiple prop changes.
     *
     * @return {void}
     */
    multiple() {
      this.clearSelection();
    },
    open(isOpen) {
      this.$emit(isOpen ? "open" : "close");
    },
    search(search) {
      if (search.length) {
        this.open = true;
      }
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    /**
     * Make sure tracked value is
     * one option if possible.
     *
     * @param  {object | string} value Reduced value to resolve.
     * @return {void}
     */
    setInternalValueFromOptions(value) {
      if (Array.isArray(value)) {
        this.$data._value = value.map((val) => this.findOptionFromReducedValue(val));
      } else {
        this.$data._value = this.findOptionFromReducedValue(value);
      }
    },
    /**
     * Select or deselect a given option.
     * Allow deselect if clearable or if not the only selected option.
     *
     * @param  {object | string} option Option to select or deselect.
     * @return {void}
     */
    select(option) {
      this.$emit("option:selecting", option);
      if (!this.isOptionSelected(option)) {
        if (this.taggable && !this.optionExists(option)) {
          this.$emit("option:created", option);
          this.pushTag(option);
        }
        if (this.multiple) {
          option = this.selectedValue.concat(option);
        }
        this.updateValue(option);
        this.$emit("option:selected", option);
      } else if (this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1)) {
        this.deselect(option);
      }
      this.onAfterSelect(option);
    },
    /**
     * De-select a given option.
     *
     * @param  {object | string} option Option to remove.
     * @return {void}
     */
    deselect(option) {
      this.$emit("option:deselecting", option);
      this.updateValue(this.selectedValue.filter((val) => {
        return !this.optionComparator(val, option);
      }));
      this.$emit("option:deselected", option);
    },
    /**
     * De-select a given option on keyboard input.
     *
     * @param  {object | string} option Option to remove.
     * @param  {number} index Index of the deselect button.
     * @return {void}
     */
    keyboardDeselect(option, index2) {
      this.deselect(option);
      const nextDeselect = this.deselectButtons?.[index2 + 1];
      const prevDeselect = this.deselectButtons?.[index2 - 1];
      const deselectToFocus = nextDeselect ?? prevDeselect;
      if (deselectToFocus) {
        deselectToFocus.focus();
      } else {
        this.searchEl.focus();
      }
    },
    /**
     * Clears the currently selected value(s)
     *
     * @return {void}
     */
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
      this.searchEl.focus();
    },
    /**
     * Called from this.select after each selection.
     *
     * @param  {object | string} option Option that was handled.
     * @return {void}
     */
    onAfterSelect() {
      if (this.closeOnSelect) {
        this.open = !this.open;
      }
      if (this.clearSearchOnSelect) {
        this.search = "";
      }
      if (this.noDrop && this.multiple) {
        this.$nextTick(() => this.$refs.search.focus());
      }
    },
    /**
     * Accepts a selected value, updates local
     * state when required, and triggers the
     * input event.
     *
     * @fires input
     * @param {object | string} value Selected value payload.
     */
    updateValue(value) {
      if (typeof this.modelValue === "undefined") {
        this.$data._value = value;
      }
      if (value !== null) {
        if (Array.isArray(value)) {
          value = value.map((val) => this.reduce(val));
        } else {
          value = this.reduce(value);
        }
      }
      this.$emit("update:modelValue", value);
    },
    /**
     * Toggle the visibility of the dropdown menu.
     *
     * @param  {Event} event Toggle trigger event.
     * @return {void}
     */
    toggleDropdown(event) {
      const targetIsNotSearch = event.target !== this.searchEl;
      if (targetIsNotSearch) {
        event.preventDefault();
      }
      const ignoredButtons = [
        ...this.deselectButtons || [],
        ...this.$refs.clearButton ? [this.$refs.clearButton] : []
      ];
      if (this.searchEl === void 0 || ignoredButtons.filter(Boolean).some((ref) => ref.contains(event.target) || ref === event.target)) {
        event.preventDefault();
        return;
      }
      if (this.open && targetIsNotSearch) {
        this.open = false;
        this.searchEl.blur();
      } else if (!this.disabled) {
        this.open = true;
        this.searchEl.focus();
      }
    },
    /**
     * Check if the given option is currently selected.
     *
     * @param  {object | string}  option Option to evaluate.
     * @return {boolean} True when selected | False otherwise
     */
    isOptionSelected(option) {
      return this.selectedValue.some((value) => this.optionComparator(value, option));
    },
    /**
     *  Can the current option be removed via the dropdown?
     *
     * @param {object | string} option Option to evaluate.
     * @return {boolean}
     */
    isOptionDeselectable(option) {
      return this.isOptionSelected(option) && this.deselectFromDropdown;
    },
    /**
     * Check if the option at the given index should display a
     * keyboard focus border.
     *
     * @param  {number} index Option index.
     * @return {boolean}
     */
    hasKeyboardFocusBorder(index2) {
      if (this.keyboardFocusBorder && this.isKeyboardNavigation) {
        return index2 === this.typeAheadPointer;
      }
      return false;
    },
    /**
     * Determine if two option objects are matching.
     *
     * @param {object} a First option.
     * @param {object} b Second option.
     * @return {boolean}
     */
    optionComparator(a, b) {
      return this.getOptionKey(a) === this.getOptionKey(b);
    },
    /**
     * Finds an option from the options
     * where a reduced value matches
     * the passed in value.
     *
     * @param {object} value Reduced value to match.
     * @return {*}
     */
    findOptionFromReducedValue(value) {
      const predicate = (option) => JSON.stringify(this.reduce(option)) === JSON.stringify(value);
      const matches = [...this.options, ...this.pushedTags].filter(predicate);
      if (matches.length === 1) {
        return matches[0];
      }
      return matches.find((match) => this.optionComparator(match, this.$data._value)) || value;
    },
    /**
     * 'Private' function to close the search options
     *
     * @fires  {search:blur}
     * @return {void}
     */
    closeSearchOptions() {
      this.open = false;
      this.$emit("search:blur");
    },
    /**
     * Delete the value on Delete keypress when there is no
     * text in the search input, & there's tags to delete
     *
     * @return {this.value}
     */
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let value = null;
        if (this.multiple) {
          value = [
            ...this.selectedValue.slice(0, this.selectedValue.length - 1)
          ];
        }
        this.updateValue(value);
      }
    },
    /**
     * Determine if an option exists
     * within this.optionList array.
     *
     * @param  {Object || String} option Option to find.
     * @return {boolean}
     */
    optionExists(option) {
      return this.optionList.some((_option) => this.optionComparator(_option, option));
    },
    /**
     * Determine the `aria-selected` value
     * of an option
     *
     * @param  {object | string} option Option to evaluate.
     * @return {null|string}
     */
    optionAriaSelected(option) {
      if (!this.selectable(option)) {
        return null;
      }
      return String(this.isOptionSelected(option));
    },
    /**
     * Ensures that options are always
     * passed as objects to scoped slots.
     *
     * @param {object | string} option Option to normalize.
     * @return {object}
     */
    normalizeOptionForSlot(option) {
      return typeof option === "object" ? option : { [this.label]: option };
    },
    /**
     * If push-tags is true, push the
     * given option to `this.pushedTags`.
     *
     * @param  {Object || String} option Option to append.
     * @return {void}
     */
    pushTag(option) {
      this.pushedTags.push(option);
    },
    /**
     * If there is any text in the search input, remove it.
     * Otherwise, blur the search input to close the dropdown.
     *
     * @return {void}
     */
    onEscape() {
      if (!this.search.length) {
        this.open = false;
      } else {
        this.search = "";
      }
    },
    /**
     * Close the dropdown on blur.
     *
     * @fires  {search:blur}
     * @return {void}
     */
    onSearchBlur() {
      if (this.mousedown && !this.searching) {
        this.mousedown = false;
      } else {
        const { clearSearchOnSelect, multiple } = this;
        if (this.clearSearchOnBlur({ clearSearchOnSelect, multiple })) {
          this.search = "";
        }
        this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
      }
    },
    /**
     * Do NOT open the dropdown here: auto-opening on focus violates
     * WCAG 3.2.1 (On Focus). Keyboard users open via
     * Space/Enter/ArrowDown/ArrowUp; mouse users click.
     *
     * @fires  {search:focus}
     * @return {void}
     */
    onSearchFocus() {
      this.$emit("search:focus");
    },
    /**
     * Event-Handler to help workaround IE11 (probably fixes 10 as well)
     * firing a `blur` event when clicking
     * the dropdown's scrollbar, causing it
     * to collapse abruptly.
     *
     * @see https://github.com/sagalbot/vue-select/issues/106
     * @return {void}
     */
    onMousedown() {
      this.mousedown = true;
    },
    /**
     * Event-Handler to help workaround IE11 (probably fixes 10 as well)
     *
     * @see https://github.com/sagalbot/vue-select/issues/106
     * @return {void}
     */
    onMouseUp() {
      this.mousedown = false;
    },
    /**
     * Event-Handler for option mousemove
     *
     * @param {object | string} option Hovered option.
     * @param {number} index Hovered option index.
     * @return {void}
     */
    onMouseMove(option, index2) {
      this.isKeyboardNavigation = false;
      if (!this.selectable(option)) {
        return;
      }
      this.typeAheadPointer = index2;
    },
    /**
     * Search <input> KeyBoardEvent handler.
     *
     * @param {KeyboardEvent} e Keyboard event.
     * @return {Function}
     */
    onSearchKeyDown(e) {
      const preventAndSelect = (e2) => {
        e2.preventDefault();
        if (!this.open) {
          this.open = true;
          return;
        }
        return !this.isComposing && this.typeAheadSelect();
      };
      const defaults = {
        //  backspace
        8: () => this.maybeDeleteValue(),
        //  tab
        9: () => this.onTab(),
        //  esc
        27: () => this.onEscape(),
        //  up.prevent
        38: (e2) => {
          e2.preventDefault();
          this.isKeyboardNavigation = true;
          if (!this.open) {
            this.open = true;
            return;
          }
          return this.typeAheadUp();
        },
        //  down.prevent
        40: (e2) => {
          e2.preventDefault();
          this.isKeyboardNavigation = true;
          if (!this.open) {
            this.open = true;
            return;
          }
          return this.typeAheadDown();
        }
      };
      this.selectOnKeyCodes.forEach((keyCode) => defaults[keyCode] = preventAndSelect);
      const handlers = this.mapKeydown(defaults, this);
      if (typeof handlers[e.keyCode] === "function") {
        return handlers[e.keyCode](e);
      }
    },
    /**
     * TODO: Probably want to add a mapKeyPress method just like we have for keydown.
     *
     * @param {KeyboardEvent} e Keyboard event.
     */
    onSearchKeyPress(e) {
      if (!this.open && e.keyCode === 32) {
        e.preventDefault();
        this.open = true;
      }
    }
  }
};
const _hoisted_1 = ["id", "dir"];
const _hoisted_2 = {
  ref: "toggle",
  class: "vs__dropdown-toggle"
};
const _hoisted_3 = ["disabled", "title", "aria-label", "onMousedown", "onKeydown"];
const _hoisted_4 = {
  ref: "actions",
  class: "vs__actions"
};
const _hoisted_5 = ["disabled", "title", "aria-label"];
const _hoisted_6 = { class: "vs__spinner" };
const _hoisted_7 = ["id", "aria-label", "aria-multiselectable"];
const _hoisted_8 = ["id", "aria-selected", "onMousemove", "onClick"];
const _hoisted_9 = {
  key: 0,
  class: "vs__no-options"
};
const _hoisted_10 = ["id", "aria-label"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_append_to_body = resolveDirective("append-to-body");
  return openBlock(), createElementBlock("div", {
    id: `v-select-${$props.uid}`,
    dir: $props.dir,
    class: normalizeClass(["v-select", $options.stateClasses])
  }, [
    renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps($options.scope.header))),
    createElementVNode("div", _hoisted_2, [
      createElementVNode("div", {
        ref: "selectedOptions",
        class: "vs__selected-options",
        onMousedown: _cache[0] || (_cache[0] = (...args) => $options.toggleDropdown && $options.toggleDropdown(...args))
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.selectedValue, (option, index2) => {
          return renderSlot(_ctx.$slots, "selected-option-container", {
            option: $options.normalizeOptionForSlot(option),
            deselect: $options.deselect,
            multiple: $props.multiple,
            disabled: $props.disabled
          }, () => [
            (openBlock(), createElementBlock("span", {
              key: $props.getOptionKey(option),
              class: "vs__selected"
            }, [
              renderSlot(_ctx.$slots, "selected-option", mergeProps({ ref_for: true }, $options.normalizeOptionForSlot(option)), () => [
                createTextVNode(toDisplayString($props.getOptionLabel(option)), 1)
              ]),
              $props.multiple ? (openBlock(), createElementBlock("button", {
                key: 0,
                ref_for: true,
                ref: (el) => $data.deselectButtons[index2] = el,
                disabled: $props.disabled,
                type: "button",
                class: "vs__deselect",
                title: $props.ariaLabelDeselectOption($props.getOptionLabel(option)),
                "aria-label": $props.ariaLabelDeselectOption($props.getOptionLabel(option)),
                onMousedown: withModifiers(($event) => $options.deselect(option), ["stop"]),
                onKeydown: withKeys(($event) => $options.keyboardDeselect(option, index2), ["enter"])
              }, [
                (openBlock(), createBlock(resolveDynamicComponent($options.childComponents.Deselect)))
              ], 40, _hoisted_3)) : createCommentVNode("", true)
            ]))
          ]);
        }), 256)),
        renderSlot(_ctx.$slots, "search", normalizeProps(guardReactiveProps($options.scope.search)), () => [
          createElementVNode("input", mergeProps({ class: "vs__search" }, $options.scope.search.attributes, toHandlers($options.scope.search.events, true)), null, 16)
        ])
      ], 544),
      createElementVNode("div", _hoisted_4, [
        withDirectives(createElementVNode("button", {
          ref: "clearButton",
          disabled: $props.disabled,
          type: "button",
          class: "vs__clear",
          title: $props.ariaLabelClearSelected,
          "aria-label": $props.ariaLabelClearSelected,
          onClick: _cache[1] || (_cache[1] = (...args) => $options.clearSelection && $options.clearSelection(...args))
        }, [
          (openBlock(), createBlock(resolveDynamicComponent($options.childComponents.Deselect)))
        ], 8, _hoisted_5), [
          [vShow, $options.showClearButton]
        ]),
        !$props.noDrop ? (openBlock(), createElementBlock("button", {
          key: 0,
          ref: "openIndicatorButton",
          class: "vs__open-indicator-button",
          type: "button",
          tabindex: "-1",
          "aria-hidden": "true",
          onMousedown: _cache[2] || (_cache[2] = (...args) => $options.toggleDropdown && $options.toggleDropdown(...args))
        }, [
          renderSlot(_ctx.$slots, "open-indicator", normalizeProps(guardReactiveProps($options.scope.openIndicator)), () => [
            (openBlock(), createBlock(resolveDynamicComponent($options.childComponents.OpenIndicator), normalizeProps(guardReactiveProps($options.scope.openIndicator.attributes)), null, 16))
          ])
        ], 544)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "spinner", normalizeProps(guardReactiveProps($options.scope.spinner)), () => [
          withDirectives(createElementVNode("div", _hoisted_6, " Loading... ", 512), [
            [vShow, _ctx.mutableLoading]
          ])
        ])
      ], 512)
    ], 512),
    createVNode(Transition, { name: $props.transition }, {
      default: withCtx(() => [
        $options.dropdownOpen ? withDirectives((openBlock(), createElementBlock("ul", {
          id: `vs-${$props.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs-${$props.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          "aria-label": $props.ariaLabelListbox,
          "aria-multiselectable": $props.multiple ? "true" : null,
          tabindex: "-1",
          onMousedown: _cache[3] || (_cache[3] = withModifiers((...args) => $options.onMousedown && $options.onMousedown(...args), ["prevent"])),
          onMouseup: _cache[4] || (_cache[4] = (...args) => $options.onMouseUp && $options.onMouseUp(...args))
        }, [
          renderSlot(_ctx.$slots, "list-header", normalizeProps(guardReactiveProps($options.scope.listHeader))),
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.filteredOptions, (option, index2) => {
            return openBlock(), createElementBlock("li", {
              id: `vs-${$props.uid}__option-${index2}`,
              key: $props.getOptionKey(option),
              role: "option",
              class: normalizeClass(["vs__dropdown-option", {
                "vs__dropdown-option--deselect": $options.isOptionDeselectable(option) && index2 === _ctx.typeAheadPointer,
                "vs__dropdown-option--selected": $options.isOptionSelected(option),
                "vs__dropdown-option--highlight": index2 === _ctx.typeAheadPointer,
                "vs__dropdown-option--kb-focus": $options.hasKeyboardFocusBorder(index2),
                "vs__dropdown-option--disabled": !$props.selectable(option)
              }]),
              "aria-selected": $options.optionAriaSelected(option),
              onMousemove: ($event) => $options.onMouseMove(option, index2),
              onClick: withModifiers(($event) => $props.selectable(option) ? $options.select(option) : null, ["prevent", "stop"])
            }, [
              renderSlot(_ctx.$slots, "option", mergeProps({ ref_for: true }, $options.normalizeOptionForSlot(option)), () => [
                createTextVNode(toDisplayString($props.getOptionLabel(option)), 1)
              ])
            ], 42, _hoisted_8);
          }), 128)),
          $options.filteredOptions.length === 0 ? (openBlock(), createElementBlock("li", _hoisted_9, [
            renderSlot(_ctx.$slots, "no-options", normalizeProps(guardReactiveProps($options.scope.noOptions)), () => [
              _cache[5] || (_cache[5] = createTextVNode(" Sorry, no matching options. ", -1))
            ])
          ])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "list-footer", normalizeProps(guardReactiveProps($options.scope.listFooter)))
        ], 40, _hoisted_7)), [
          [_directive_append_to_body]
        ]) : (openBlock(), createElementBlock("ul", {
          key: 1,
          id: `vs-${$props.uid}__listbox`,
          role: "listbox",
          "aria-label": $props.ariaLabelListbox,
          style: { "display": "none", "visibility": "hidden" }
        }, null, 8, _hoisted_10))
      ]),
      _: 3
    }, 8, ["name"]),
    renderSlot(_ctx.$slots, "footer", normalizeProps(guardReactiveProps($options.scope.footer)))
  ], 10, _hoisted_1);
}
const Select = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const index = { ajax, pointer, pointerScroll };
export {
  Select as VueSelect,
  index as mixins
};
//# sourceMappingURL=index.mjs.map
